<template>
  <AllegroJsonForm
    title="Edytuj odbiorcę COD Allegro"
    crumbLabel="Edycja odbiorcy"
    :settingsCrumb="true"
    submitAction="updateAllegroCodReceiver"
    submitGetter="getAllegroCodReceiverUpdateData"
    loadAction="getAllegroCodReceiver"
    loadGetter="getAllegroCodReceiverData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroCodReceiverPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroCodReceiverUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroCodReceiverPermissionsConst.update,
      fields: [
        { key: "name", label: "Nazwa", required: true },
        { key: "iban", label: "Nr konta (IBAN)", required: true },
      ],
    };
  },
};
</script>
